import AppConstants from '../constants/AppConstants';
import { getTotalPages } from './helper';

export const initialState = {
    activationCode: {},
    loadingActivationCode: false,
    method: {},
    methodLoading: false,
    list: [],
    page: 1,
    total: null,
    loading: false,
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {

        case AppConstants.PAYMENT_DETAILS_SEARCH_START_LOADING:
            return {
                ...state,
                loading: true,
            };

        case AppConstants.PAYMENT_DETAILS_SEARCH_SUCCESS:
            return {
                ...state,
                loading: false,
                list: action.items.items,
                page: action.items.page,
                total: getTotalPages(action.items.total, action.items.count)
            };

        case AppConstants.PAYMENT_DETAILS_SEND_ACTIVATION_CODE_START_LOADING:
            return {
                ...state,
                loadingActivationCode: true
            };

        case AppConstants.PAYMENT_DETAILS_SEND_ACTIVATION_CODE_SUCCESS:
            return {
                ...state,
                loadingActivationCode: false,
                activationCode: action.items
            };

        case AppConstants.PAYMENT_DETAILS_SEND_ACTIVATION_CODE_FAIL:
            return {
                ...state,
                loadingActivationCode: false,
                activationCode: action.items
            };

        case AppConstants.PAYMENT_DETAILS_METHOD_START_LOADING:
            return {
                ...state,
                methodLoading: true,
            };

        case AppConstants.PAYMENT_DETAILS_METHOD_SUCCESS:
            return {
                ...state,
                methodLoading: false,
                method: action.items.items[0],
            };

        default:
            return state;
    }
};
